// ResourceLanguageWarning.jsx

import { useTranslation } from 'react-i18next';
import { useLanguage } from './LanguageContext';
import AVIcon from '../components/icons/AllVoicedIcons';

function ResourceLanguageWarning({ resourceKey }) {
  const { t } = useTranslation();
  const { appLanguage, resourceLanguages } = useLanguage();

  const availableLanguages = resourceLanguages[resourceKey] || [];
  const isUnavailable = !availableLanguages.includes(appLanguage);

  if (!isUnavailable) return null;

  const translatedList = availableLanguages
    .map((code) => t(`language_names.${code}`))
    .join(', ');

  return (
    <div className="warning-message">
      <AVIcon icon="info" size={20} color="#209385" />
      <span>{t('resource_available_languages', { languages: translatedList })}</span>
    </div>
  );
}

export default ResourceLanguageWarning;
